<template>
  <svg
    class="ticketIcon productIcon"
    viewBox="0 0 83 90"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    xml:space="preserve"
    xmlns:serif="http://www.serif.com/"
    style="
      fill-rule: evenodd;
      clip-rule: evenodd;
      stroke-linecap: round;
      stroke-linejoin: round;
      stroke-miterlimit: 1.5;
    "
  >
    <rect id="Prancheta3" x="0" y="0" width="83" height="90" style="fill: none" />
    <g>
      <g>
        <path
          class="hasStroke"
          d="M9.954,54.947l3.139,-3.139"
          style="fill: none; stroke: #000; stroke-width: 3px"
        />
        <path
          class="hasStroke"
          d="M9.954,54.947l20.936,20.73l9.314,-9.314c-1.294,-1.294 -1.257,-3.374 0.037,-4.668c1.294,-1.294 3.393,-1.294 4.687,0l27.217,-27.478l-4.937,-4.937"
          style="fill: none; stroke: #000; stroke-width: 3px"
        />
        <path
          class="hasStroke"
          d="M37.47,59.192l1.64,1.64"
          style="
            fill: none;
            stroke: #000;
            stroke-width: 1.5px;
            stroke-linecap: butt;
            stroke-dasharray: 3, 1.5, 0, 0;
          "
        />
        <path
          class="hasStroke"
          d="M64.325,32.19l4.937,4.937"
          style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M33.517,63.146l4.863,4.863"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M26.417,71.248l8.902,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M22.942,67.808l5.254,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M29.648,67.808l9.111,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M19.465,64.365l6.51,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M32.298,64.365l2.439,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M15.437,61.067l7.207,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M12.596,57.539l6.485,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M10.472,54.204l5.241,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
      </g>
      <g>
        <path
          class="hasStroke"
          d="M49.676,5.319l-27.478,27.423c1.294,1.294 1.294,3.393 0,4.687c-1.295,1.294 -3.374,1.331 -4.668,0.037l-9.314,9.314l20.936,20.731l9.314,-9.315c-1.294,-1.294 -1.257,-3.373 0.037,-4.668c1.294,-1.294 3.393,-1.294 4.687,0l27.217,-27.478l-20.731,-20.731"
          style="fill: none; stroke: #000; stroke-width: 3px"
        />
        <path
          class="hasStroke"
          d="M23.168,38.462l14.204,14.203"
          style="
            fill: none;
            stroke: #000;
            stroke-width: 1.5px;
            stroke-linecap: butt;
            stroke-dasharray: 3, 1.5, 0, 0;
          "
        />
        <path
          class="hasStroke"
          d="M33.585,31.833l11.397,-11.398"
          style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M36.474,34.723l11.398,-11.398"
          style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M39.167,37.415l7.61,-7.61"
          style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M46.777,8.213l20.747,20.747"
          style="fill: none; stroke: #000; stroke-width: 2px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M15.895,39.095l20.747,20.747"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M24.679,63.082l8.902,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M21.204,59.641l15.817,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M17.727,56.198l15.272,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M13.699,52.9l16.002,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M10.858,49.372l15.314,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M8.734,46.037l13.643,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
        <path
          class="hasStroke"
          d="M12.752,43.115l7.164,0"
          style="fill: none; stroke: #000; stroke-width: 1.5px; stroke-linecap: butt"
        />
      </g>
    </g>
  </svg>
</template>
